module.exports = __webpack_public_path__ + "img/trophy6.jpg";